<template>
    <div :class="[defaultClasses, classes]">
        <div class="self-stretch h-24 flex-col justify-start items-start flex">
            <div class="self-stretch justify-start items-center inline-flex">
                <div
                    class="text-neutral-900 text-base font-bold font-Open gap-2">
                    {{ label }}
                </div>
                <div
                    class="text-neutral-500 text-base font-normal font-Open leading-normal ml-2 gap-2">
                    (optional)
                </div>
            </div>
            <div
                class="self-stretch text-zinc-800 text-sm font-normal font-Open leading-tight gap-2">
                {{ subtext }}
            </div>
            <MazSelect
                class="w-full max-584"
                v-model="selectedValue"
                label="Select"
                :color="color"
                :options="placeholderOptions" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import MazSelect from 'maz-ui/components/MazSelect';
    import { ref, computed } from 'vue';

    const props = defineProps({
        label: String,
        subtext: String,
        classes: String,
        type: Number,
    });

    const selectedValue = ref();

    const placeholderOptions = [
        { label: 'Lose weight', value: 'primary' },
        { label: 'Get toned', value: 'secondary' },
        { label: 'Increase my muscle mass', value: 'info' },
        { label: 'Improve my health and longevity', value: 'success' },
        { label: 'I am not sure', value: 'warning' },
    ];

    const defaultClasses = computed(() => {
        // Define the default classes based on the type prop
        return props.type === 2
            ? ''
            : 'px-6 pt-4 flex-col flex justify-start items-start inline-flex bg-white';
    });
</script>
